module.exports = __webpack_public_path__ + "videos/video-aleo-graphism.91182bd.mp4";